import React from "react"
import RecentPost from "../post/recentPost"
// import Hero from "../components/post/hero"
import HireMe from "../post/hireMe"

import EmailListForm from "../Features/mailChip"
export default function SideBar() {
  return (
    <div className="mb-3">
      <div className="mb-2">
        <EmailListForm />
      </div>
      {/* <div>
        <CardTitle className=" bg-white center mt-2 p-4 w-100 shadow">
          <h4 className="text-center text-uppercase">
            advertisement
            <div className="p-5 mt-2 bg-secondary text-white border border-dark">
              300x300
            </div>
          </h4>
        </CardTitle>
      </div> */}
      <RecentPost />
      <HireMe />
    </div>
  )
}
